export default __webpack_public_path__ + "static/media/teacher.0d97697c.png";